import React, { useRef, useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import Chevron from './Chevron';
import Clear from './Clear';
import Item from './Item';
import Menu from './Menu';
import Toggle from './Toggle';
import { NotNestedDropDownElement } from '../../constants';

const Dropdown = ({ children, className, disabled, doOpenDatePicker, setDoOpenDatePicker }) => {
  const node = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const handleToggleClick = () => {
    if (disabled) return;
    setIsOpen((v) => !v);
    if (setDoOpenDatePicker) setDoOpenDatePicker(!isOpen);
  };

  const close = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (disabled) return;
      if (
        (node.current && node.current.contains(e.target)) ||
        e.target.classList.contains(NotNestedDropDownElement)
      ) {
        // inside click
        return;
      }
      // outside click
      setIsOpen(false);
    };

    // add when mounted
    if (typeof window !== 'undefined') {
      document.addEventListener('mousedown', handleClick);
    }

    // return function to be called when unmounted
    return () => {
      if (typeof window !== 'undefined') {
        document.removeEventListener('mousedown', handleClick);
      }
    };
  }, [disabled]);

  useEffect(() => {
    setIsOpen(doOpenDatePicker);
  }, [doOpenDatePicker]);

  return (
    <div ref={node} className={clsx('relative inline-block text-left', className)}>
      {React.Children.map(children, (child) => {
        let p = { isOpen, close };
        if (child.type.name === Toggle.name) p = { ...p, onClick: handleToggleClick };
        if (child.type.name === Menu.name) p = { ...p, close };
        return React.cloneElement(child, p);
      })}
    </div>
  );
};

Dropdown.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  doOpenDatePicker: PropTypes.bool,
  setDoOpenDatePicker: PropTypes.func,
};

Dropdown.defaultProps = {
  className: undefined,
  disabled: false,
  doOpenDatePicker: false,
  setDoOpenDatePicker: () => {},
};

Toggle.Clear = Clear;
Toggle.Chevron = Chevron;
Dropdown.Toggle = Toggle;
Dropdown.Menu = Menu;
Dropdown.Item = Item;

export default Dropdown;
